/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box, Text, Stack } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';
import { get, map } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllLocations } from 'state/locations/selectors';
import FormLabel from 'components/forms/form-label';
import FormTextInput from 'components/forms/form-text-input';
import FormSelect from 'components/forms/form-select';
import FormMultiCheckbox from 'components/forms/form-multi-checkbox';
import { getEditedLocationGroup } from 'state/location-groups/selectors';
import { editLocationWebsite, saveLocationWebsite } from 'state/location-websites/actions';

/**
 * Style dependencies
 */
import './styles.scss';

// the location must be loaded before using this class

const LocationWebsiteForm = ({ locationWebsiteId, locationWebsite, locations, connectionLocations, connectionId, disabled, ...props }) => {
    const handleOnChange = (name, value) => {
        props.editLocationWebsite(locationWebsiteId, {
            [name]: value,
        });
    };

    const handleOnChangeDD = (e) => {
        props.editLocationWebsite(locationWebsiteId, {
            [e.target.name]: e.target.value,
        });


    };

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        props.beforeSubmit && props.beforeSubmit(locationWebsite);

        try {
            let response = await props.saveLocationWebsite(locationWebsiteId, locationWebsite);
            props.afterSuccessfullSubmit && props.afterSuccessfullSubmit(response);
        } catch (error) {}

        props.afterSubmit && props.afterSubmit();
    };

    const isShown = disabled ? 'none' : 'block';

    return (
        <form id='location-website-form' onSubmit={handleOnSubmit}>
            <Stack space='large'>
                <Box>
                    <FormLabel>Name:</FormLabel>
                    <FormTextInput
                        name='name'
                        value={get(locationWebsite, 'name', '')}
                        onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                    />
                </Box>
                <Box display={isShown}>
                    <FormLabel>Website ID:</FormLabel>
                    <Text size='xsmall'>Unique identifier of website at eCommerce platform.</Text>
                    <FormTextInput
                        name='website_id'
                        value={get(locationWebsite, 'website_id', '')}
                        onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                        disabled = {disabled}
                    />
                </Box>
                <Box>
                    <FormLabel>Inventory locations:</FormLabel>
                    <Text size='xsmall'>
                        Choose a Retailer location to link to the website ID.
                    </Text>
                    <Box marginTop='medium'>
                        <FormSelect
                            onChange={handleOnChangeDD}
                            name='locations'             
                            value={(get(locationWebsite, 'locations'))}
                        >
                            <option value='' />,
                            {map(locations, (location) => (
                                <option value={location.id} key={location.id}>
                                    {location.name}
                                </option> : ''
                            ))}

                        </FormSelect>
                    </Box>
                </Box>
            </Stack>
        </form>
    );
};

export default connect(
    (state, ownProps) => ({
        locations: getAllLocations(state),
    }),
    {
        editLocationWebsite,
        saveLocationWebsite,
    },
)(LocationWebsiteForm);
